"use client";

import { useEffect, useState } from "react";

export default function PiRateDisplay({ rate }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  // ✅ stable SSR + first client render
  if (!mounted) {
    return (
      <div className="text-sm text-textSecondary">
        📈 Live PI/USD Bitget API{" "}
        <span className="font-semibold text-textPrimary">—</span>
      </div>
    );
  }

  return (
    <div className="text-sm text-textSecondary">
      📈 Live PI/USD Bitget API{" "}
      <span className="font-semibold text-textPrimary">
        ${Number(rate || 0).toFixed(4)}
      </span>
    </div>
  );
}
